import { render } from "./Comentar.vue?vue&type=template&id=af97e144"
const script = {}
script.render = render

export default script